<template>
  <div id="app">
    <keep-alive>
      <router-view
        v-if="$route.meta.keepAlive"
        style="width: 100%; overflow: hidden;"
      ></router-view>
    </keep-alive>
    <router-view
      v-if="!$route.meta.keepAlive"
      style="width: 100%; overflow: hidden;"
    ></router-view>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "App",
  computed: {
    ...mapState(["isPc"]),
  },
  created() {
    this.$store.dispatch("checkWindowWidth");
  },
};
</script>


// WEBPACK FOOTER //
// src/App.vue